import { getBlock } from "../service/getBlock";
import { IGroupProduct } from "../views/ecommerce/group/interfaces";

export const getGroups = async (
    login: any, 
    setGroups: (group: IGroupProduct[]) => void
): Promise<void> => {
    const { block } = await getBlock("/donations/camp/list", {
        sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
        page: 1
    });

    setGroups(block.donationsCamp);
}